import {Component, h, Prop, State} from '@stencil/core';

/**
 * @slot default - The actual text.
 */
@Component({
    tag: 'joy-time-saving-calculator',
    shadow: true,
    styles: `
        :host {
            display: block;
            padding: var(--joy-core-spacing-6);
            background-color: var(--joy-color-neutral-10);
            border: 1px solid var(--joy-color-neutral-30);
        }
    `,
})
export class Text {
    @State() timeDiff = 0;

    @Prop() ds = 5;
    @Prop() handmade = 30;
    @Prop() instance = 300;

    private updateTime = () => {
        this.timeDiff = this.handmade - this.ds;
    };

    private setDsTime = (e: any) => {
        this.ds = parseInt(e.detail.value);
        this.updateTime();
    };

    private setHandMadeTime = (e: any) => {
        this.handmade = parseInt(e.detail.value);
        this.updateTime();
    };

    private setInstanceAmount = (e: any) => {
        this.instance = parseInt(e.detail.value);
    };

    componentWillLoad() {
        this.updateTime();
    }

    render() {
        return (
            <div>
                <joy-wrapper>
                    <joy-input unit="minutes" value={this.ds.toString()} onJoy-input-change={this.setDsTime}>
                        Component implementation time (design system)
                    </joy-input>
                    <joy-input unit="minutes" value={this.handmade.toString()} onJoy-input-change={this.setHandMadeTime}>
                        Component implementation time (from scratch)
                    </joy-input>
                    <joy-input type="number" value={this.instance.toString()} onJoy-input-change={this.setInstanceAmount}>
                        Total Instances
                    </joy-input>
                </joy-wrapper>
                <joy-wrapper>
                    <joy-highlight level="neutral">
                        <i>
                            {this.timeDiff} minutes diff x {this.instance} components = {this.timeDiff * this.instance} minutes
                        </i>
                        <br />
                        <small>
                            {Math.round((this.timeDiff * this.instance) / 1440)} full days. A workday is about 8 hours so we need to multiply the
                            result by 3.
                        </small>
                    </joy-highlight>
                    <joy-tag size="large" variant="special">
                        {Math.round((this.timeDiff * this.instance) / 1440) * 3} work days saved
                    </joy-tag>
                </joy-wrapper>
            </div>
        );
    }
}
